import { render } from "./Aanmelden.vue?vue&type=template&id=c7cf70ca"
import script from "./Aanmelden.vue?vue&type=script&lang=js"
export * from "./Aanmelden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__